import {
  ConfirmationNumber,
  OndemandVideo,
  Pause,
  PlayArrow,
  Replay,
} from '@mui/icons-material';

import { ChapterState } from '@/types';

export const ChapterTileIcon = ({
  index,
  chapterState,
  chapterType,
  isChapterPlaying,
  isChapterVerifiable,
  isEpisodeRedeemRequired,
  isIconHovered,
}: {
  index: number;
  chapterState: ChapterState;
  chapterType: string;
  isChapterPlaying: boolean;
  isChapterVerifiable: boolean;
  isEpisodeRedeemRequired: boolean;
  isIconHovered: boolean;
}) => {
  const PlayIcon = chapterType === 'video' ? OndemandVideo : PlayArrow;

  if (isEpisodeRedeemRequired && isChapterVerifiable && index > 0)
    return <ConfirmationNumber sx={styles.icon} />;

  if (isChapterPlaying) return <Pause sx={styles.icon} />;

  if (
    chapterState === 'quiz_ready' ||
    chapterState === 'verified' ||
    chapterState === 'completed'
  ) {
    if (isIconHovered) return <PlayIcon sx={styles.icon} />;
    return <Replay sx={styles.icon} />;
  }

  return <PlayIcon sx={styles.icon} />;
};

const styles = {
  icon: {
    color: 'secondary.main',
    fontSize: 18,
  },
};
